/**
 * Ativa classe `sp-design-v2` no documento (visual v2 em produção).
 * Overrides em `ant-overrides.css` dependem desta classe.
 */

const DESIGN_V2_CLASS = 'sp-design-v2';

/** Sempre v2 — mantido para compatibilidade de imports em páginas públicas. */
export const isDesignV2Enabled = (): boolean => true;

export const applyDesignV2Flag = (): void => {
  if (typeof document === 'undefined') {
    return;
  }
  document.documentElement.classList.add(DESIGN_V2_CLASS);
};
